<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="secondary">
      <ion-back-button defaultHref="/net-sheet"></ion-back-button>
    </ion-buttons>

    <ion-buttons slot="primary">
      <ion-button (click)="send()"> Save<ion-icon slot="end" name="download-outline"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title>Estimated Net Sheet</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  @if ((hasCalculatorReport$ | async) === true) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    @let subtitles = subtitles$ | async; @if (subtitles && subtitles.length) {
    <ion-item>
      <ion-label>
        @for (subtitle of subtitles; track subtitle) {
        <div class="tw:text-base tw:font-bold">{{ subtitle }}</div>
        }
      </ion-label>
    </ion-item>
    }
  </ion-list>

  @let sections = sections$ | async; @if (sections && sections.length) { @for (section of sections; track section; let i
  = $index) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item>
      <ion-label>
        <div class="tw:grid tw:grid-cols-12">
          <div class="tw:col-span-4">
            <span class="tw:text-base tw:font-bold"> {{ section.title }}</span>
          </div>
          @if (i === 0) {
          <div class="tw:col-span-4 tw:text-right tw:font-bold">Credit</div>
          <div class="tw:col-span-4 tw:text-right tw:font-bold">Debit</div>
          }
        </div>
      </ion-label>
    </ion-item>

    @if (section.items && section.items.length) { @for (item of section.items; track item) {
    <ion-item>
      <ion-label>
        <div class="tw:grid tw:grid-cols-12">
          <div class="tw:col-span-4">
            <span class="tw:inline-grid tw:text-sm">{{ item.name }}</span>
            @if (item.description) {
            <div class="tw:text-xs tw:text-gray-500 tw:italic">({{ item.description }})</div>
            }
          </div>
          <div class="tw:col-span-4 tw:flex tw:items-center tw:justify-end tw:text-right">
            @if (item.isCredit) {
            <ion-note color="dark" class="tw:text-xs tw:whitespace-nowrap">{{ item.value }}</ion-note>
            }
          </div>
          <div class="tw:col-span-4 tw:flex tw:items-center tw:justify-end tw:text-right">
            @if (!item.isCredit) {
            <ion-note color="dark" class="tw:text-xs tw:whitespace-nowrap">{{ item.value }}</ion-note>
            }
          </div>
        </div>
      </ion-label>
    </ion-item>
    } }
  </ion-list>
  } } @if (hasFooter$ | async) {
  <div class="tw:mb-4 tw:flex tw:flex-col tw:gap-4">
    @let notes = notes$ | async; @if (notes?.length) {
    <div class="tw:px-4 tw:text-justify tw:text-xs tw:font-bold">
      @for (note of notes; track note) {
      <p class="tw:my-2">{{ note }}</p>
      }
    </div>
    } @let disclaimers = disclaimers$ | async; @if (disclaimers?.length) {
    <ion-accordion-group expand="inset" class="tw:my-0">
      <ion-accordion value="disclaimers">
        <ion-item slot="header" color="secondary">
          <ion-label>Legal Information</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          <div class="tw:text-justify tw:text-xs">
            @for (disclaimer of disclaimers; track disclaimer) {
            <p class="tw:mb-4">{{ disclaimer }}</p>
            }
          </div>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    } @let copyright = copyright$ | async; @if (copyright) {
    <div class="tw:px-4 tw:text-center tw:text-xs">
      <p>{{ copyright }}</p>
    </div>
    }
  </div>
  } }
</red-page-content>
